import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";

const Implementations = (props) => {
    const [implementationProjectsData, setImplementationProjectsData] = useState([]);

    useEffect(() => {
        let data = props.data;

        // Check for empty data and skip processing
        if (data.length === 0) return;

        // Check for undefined values and replace
        data = data.map((item) => {
            Object.keys(item).forEach((key) => {
                if (item[key] === undefined || item[key] === null) {
                    item[key] = "-";
                }
            });
            return item;
        });

        // Sort data by primary license
        // data.sort((a, b) => {
        //   if (a.is_primary === "Y" && b.is_primary !== "Y") return -1;
        //   else if (a.is_primary !== "Y" && b.is_primary === "Y") return 1;
        //   else return 0;
        // });

        setImplementationProjectsData(data);
    }, [props.data]);

    const columns = [
        {
            name: "product",
            label: "Product",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "owner",
            label: "Owner",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "100px",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "100px",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "kick_off_date",
            label: "Kick Off Date",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "go_live_date",
            label: "Go Live Date",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "closure_date",
            label: "Closure Date",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
    ];

    const options = {
        responsive: "standard",
        selectableRows: "none",
        filter: false,
        sort: false,
        viewColumns: false,
        print: false,
        download: false,
        search: false,
        columnOrder: null,
        fixedHeader: true,
        pagination: false,
        // rowsPerPage: 5,
        // rowsPerPageOptions: [5, 10, 25, 50, 100],
    };

    return (
        <div className="mt-12 flex w-full flex-col">
            <h4 className="pb-2">Implementation Projects</h4>

            <MUIDataTable
                data={implementationProjectsData}
                columns={columns}
                options={options}
                style={{ marginTop: "50px" }}
                className="ngShadow"
            />
        </div>
    );
};

export default Implementations;
